import React from "react";
import HeroSecond from "./HeroSecond";
import AboutDeepak from "./AboutDeepak";
import BuildingPurpose from "./BuildingPurpose";
import KeyProjects from "./KeyProjects";
import MoreBussiness from "./MoreBussiness";
import AboutContact from "./AboutContact";
import ClientReviews from "../new-hero/ClientReviews";

const AboutEnterpreneur = () => {
  return (
    <>
      <HeroSecond />
      <AboutDeepak />
      <BuildingPurpose />
      <KeyProjects />
      <MoreBussiness />
      <ClientReviews />
      <AboutContact />
    </>
  );
};

export default AboutEnterpreneur;
